import { api } from './client';
import type { KingdomDossierDto, KingdomRelationshipsResponse } from '../types/dossier';

/**
 * Fetches the Kingdom Dossier for the given target kingdom.
 *
 * Returns HTTP 200 with empty provinces array for nonexistent kingdoms (D22).
 */
export async function getKingdomDossier(
  worldId: string,
  targetKingdomId: string
): Promise<KingdomDossierDto> {
  const response = await api.get<KingdomDossierDto>(
    `/api/worlds/${worldId}/intel/kingdom/${targetKingdomId}/dossier`
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to fetch dossier');
  }
  return response.data;
}

/**
 * Fetches WAR/HOSTILE relationships for a kingdom.
 *
 * Returns HTTP 200 with empty relationships array for nonexistent kingdoms (D22).
 */
export async function getKingdomRelationships(
  worldId: string,
  kingdomId: string
): Promise<KingdomRelationshipsResponse> {
  const response = await api.get<KingdomRelationshipsResponse>(
    `/api/worlds/${worldId}/kingdoms/${kingdomId}/relationships`
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to fetch relationships');
  }
  return response.data;
}
